import { ContentItem } from 'kentico-cloud-delivery';

import get from 'lodash/get';

export default class Accordion extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
    });
  }

  get title() {
    return get(this, '_title.text', '');
  }

  get accordionItems() {
    return get(this, '_accordion_items', []);
  }

  get id() {
    return get(this, 'system.id', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/FAQAccordion.model.js